jQuery(function () {
  $("document").ready(function () {
    if ($(".engravingproduct").length) {
$(".engravingtext").hide();
      $("input[name=template--15704161255630__main-engraving-option]:radio").click(function () {
        console.log('test');
        if ($('input[name=template--15704161255630__main-engraving-option]:checked').val() == "Yes") {
            $(".engravingtext").show();
console.log('test1');
        } else if ($('input[name=template--15704161255630__main-engraving-option]:checked').val() == "No") {
            $(".engravingtext").hide();

        }
    });
   
  }
     $("#engravingtextbold").click(function () {
        $("#engraving-text").css({
          "font-family": "'Libre Baskerville', serif",
          "font-size": "22px",
        });
      });
      $("#engravingtextscript").click(function () {
        $("#engraving-text").css({
          "font-family": "'Great Vibes', cursive",
           "font-size": "22px",
        });
      });
});
});

if($(window).innerWidth() >= 767) {

  $(window).scroll(function(){
  var sticky = $('.main-nav-bar'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('sticky');
  else sticky.removeClass('sticky');
});

$(window).scroll(function(){
  var sticky2 = $('.utils-bar'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky2.addClass('sticky2');
  else sticky2.removeClass('sticky2');
});

}


